import script from "./UserThirdBind.vue?vue&type=script&setup=true&lang=js"
export * from "./UserThirdBind.vue?vue&type=script&setup=true&lang=js"

import "./UserThirdBind.vue?vue&type=style&index=0&id=3776d443&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3776d443"]])

export default __exports__